/** @jsx jsx */
import { jsx } from '@emotion/core'
import style from './orderItemStyle';
import React from 'react';

import { Button, ErrorMessage } from '../../../components';
import utils from '../../../utils';

import { CartSummary } from '../cartSummary/summary';

export function OrderItems({ cart, form, moveNext, post, remove }) {
  //const model = form.model;

  const items = form.findControl('items').controls;
  const render = (name, parent = null) => form.renderControl(name, parent);
  const checkMinimumQtyList = cart.checkMinimumQtyList || [];
  const logoGroupNotices = cart.logoGroupNotices || [];

  // Filter to only orderItems (type 0) - matches form structure
  const orderItemsOnly = cart.orderItems.filter(x => x.orderItemType === 0);

  function itemAmount(item, orderItem) {
    const val = item.getValue()
    return (val.quantity * (orderItem.unitPrice * 100)) / 100;
  }

  const next = (e) => {
    form.validateForm(e, () => {
      moveNext();
    })
  }

  function ItemVariantSummary({ orderItem }) {
    if (!orderItem.variantOptionsSerialised) return null;
    
    try {
      const options = JSON.parse(orderItem.variantOptionsSerialised);
      return <div>
        {options
          .filter(x => !(x.Name && x.Name.toLowerCase() === 'personalisation'))
          .map((x, index) => 
            <div key={index}>
              <span css={style.optionName}>{x.Name}:</span>{' '}
              <span css={style.optionValue}>{x.Value}</span>
            </div>
          )}
      </div>
    } catch (error) {
      console.error('Failed to parse variant options:', error);
      return null;
    }
  }

  function ItemDecorationTypes({ orderItem }) {
    if (!orderItem.decorationTypes || orderItem.decorationTypes.length === 0) return null;
    return (
      <div style={{ marginTop: '0.3rem' }}>
        <span css={style.optionName}>Decoration Type:</span>{' '}
        <span css={style.optionValue}>{orderItem.decorationTypes.join(', ')}</span>
      </div>
    );
  }

  function ItemPersonalisation({ orderItem }) {
    // Get personalization descriptions (handle both camelCase and PascalCase)
    let descriptions = orderItem.orderItemDescriptions || orderItem.OrderItemDescriptions;
    
    // If not found directly, try from Ext/ext object
    if (!descriptions && orderItem.ext) {
      descriptions = orderItem.ext.orderItemDescriptions || orderItem.ext.OrderItemDescriptions;
    }
    if (!descriptions && orderItem.Ext) {
      descriptions = orderItem.Ext.orderItemDescriptions || orderItem.Ext.OrderItemDescriptions;
    }
    
    if (!descriptions || descriptions.length === 0) {
      return null;
    }
    
    return (
      <div css={style.personalisationSection}>
        {descriptions.map((desc, index) => {
          let text = (desc.desc || desc.Desc || '').trim();
          
          // Handle combined formats like "name_and_number (Name: John, Number: 10)"
          if (text.includes('(') && text.includes(')')) {
            const start = text.indexOf('(');
            const end = text.lastIndexOf(')');
            if (end > start) {
              text = text.substring(start + 1, end);
            }
          }
          
          // Split the text to parse individual items like "name: John, Number: 10"
          const items = text.split(', ').filter(item => item && item.trim().length > 0);
          
          return items.map((item, itemIndex) => {
            // Check if item already has a colon in the value part
            let label, value;
            
            if (item.includes(':')) {
              // Split on first colon only
              const colonIndex = item.indexOf(':');
              label = item.substring(0, colonIndex).trim();
              value = item.substring(colonIndex + 1).trim();
              
              // Normalize label names
              if (label.toLowerCase() === 'personalisation' || label.toLowerCase() === 'personalization') {
                label = 'Personalisation';
              } else if (label.toLowerCase() === 'name') {
                label = 'Name';
              } else if (label.toLowerCase() === 'number') {
                label = 'Number';
              }
              // Keep other labels as is
            } else {
              // No colon, treat as plain personalisation text with "Name:" label
              label = 'Name';
              value = item.trim();
            }
            
            return (
              <div key={`${index}-${itemIndex}`} css={style.personalisationItem}>
                <span css={style.optionName}>{label}:</span>{' '}
                <span css={style.optionValue}>{value}</span>
              </div>
            );
          });
        })}
      </div>
    );
  }

  const taxLines = cart.orderItems.filter(x => x.orderItemType === 1);

  // Helper function to get the original index in cart.orderItems (includes all types)
  const getOriginalIndex = (orderItemId) => {
    return cart.orderItems.findIndex(item => item.orderItemId === orderItemId);
  };

  // Ensure items array matches orderItemsOnly array
  if (items.length !== orderItemsOnly.length) {
    console.warn('Form items count does not match orderItems count:', {
      itemsCount: items.length,
      orderItemsCount: orderItemsOnly.length
    });
  }

  return <div>
    <div className="row" >
      <div className="col-md-9">
        {
          checkMinimumQtyList.length > 0 &&
          <GetCheckMinimumQtyList list={checkMinimumQtyList} />
        }
        {
          logoGroupNotices.length > 0 &&
          <LogoGroupNoticeList list={logoGroupNotices} />
        }
        <form css={style.items}>
          {orderItemsOnly.map((orderItem, index) => {
            const originalIndex = getOriginalIndex(orderItem.orderItemId);
            
            // Safety check for form item
            if (index >= items.length) {
              console.error('Form item index out of bounds:', { index, itemsLength: items.length });
              return null;
            }
            
            return <div id={`order__item__index__id__${orderItem.orderItemId}`} key={orderItem.orderItemId} css={style.item}>

            <div className="row">
              <div className="col-sm-2">
                <img src={orderItem.thumbnailUrl} alt="immmm" style={{ width: '100%' }} />
              </div>

              <div className="col-sm-5">
                <b dangerouslySetInnerHTML={{ __html: orderItem.itemName }}></b>
                <div>
                  <b>{utils.money.formatMoney(((orderItem.unitPrice * 100) / 100))} (Exc Tax)</b>
                  {
                    orderItem.unitIncTaxPrice && orderItem.unitIncTaxPrice > 0 &&
                    <span style={{ fontSize: '0.8rem', marginLeft: '0.5rem' }}>{utils.money.formatMoney(((orderItem.unitIncTaxPrice * 100) / 100))} (Inc Tax)</span>
                  }
                </div>
                <div>
                  <ItemVariantSummary orderItem={orderItem} />
                </div>
                <ItemDecorationTypes orderItem={orderItem} />
                <ItemPersonalisation orderItem={orderItem} />
              </div>

              <div className="col-sm-2" onMouseEnter={() => {
                const i = document.querySelector(`#order__item__index__id__${orderItem.orderItemId} input`);
                if (i) {
                  i.focus();
                }
              }} onMouseLeave={() => {
                const i = document.querySelector(`#order__item__index__id__${orderItem.orderItemId} input`);
                if (i) {
                  i.blur();
                }
              }}>
                Qty: {render('quantity', items[index])}
              </div>

              <div className="col-sm-3" css={style.remove}>
                <b>{utils.money.formatMoney(itemAmount(items[index], orderItem))} </b> <span style={{ display: 'inline-block', fontSize: '0.8rem', marginBottom: '0.5rem' }}> (Exc Tax) </span>
                <Button 
                  btnStyle="outline-dark" 
                  className="btn-sm" 
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    remove(e, originalIndex);
                  }} 
                  status={post.status}
                  disabled={post.loading()}
                >
                  Remove
                </Button>
              </div>

            </div>

          </div>})}
          {taxLines.map((orderItem, index) => <div key={orderItem.orderItemId} css={style.item}>
            <div css={style.product}>
              Tax: {orderItem.itemName}
            </div>
            <div css={style.details}>
              <div css={style.qty}>

              </div>
              <div css={style.amount}>
                <b>{utils.money.formatMoney(orderItem.unitPrice)}</b>

              </div>
              <div css={style.remove}>

              </div>
            </div>
          </div>)}

        </form>

      </div>
      <div className="col-md-3">
        <CartSummary cart={cart} />
      </div>
      <div className="col-md-9 form__actions" style={{ textAlign: 'center' }}>
        <Button onClick={next} status={form.status} checkDisabled={checkMinimumQtyList.length > 0 ? true : false}>Next</Button>
        <ErrorMessage errors={form.errors} summaryMessage="Please review the errors." />
      </div>
      {
        checkMinimumQtyList.length > 0 &&
        <div className='col-12' style={{ marginTop: '1rem' }}>
          <GetCheckMinimumQtyList list={checkMinimumQtyList} />
        </div>
      }
    </div>
  </div>
}

function GetCheckMinimumQtyList({ list }) {
  return (
    <div css={style.check__minimum__qty__list} className="check__minimum__qty__list">
      {
        list.map((item, index) =>
          <div key={index} css={style.check__minimum__qty__item} className="check__minimum__qty__item">
            {`* Minimum quantity of ${item.minimumQty} items not met for ${item.logoGroupName || item.productName}`}
          </div>)
      }
    </div>
  )
}

function LogoGroupNoticeList({ list }) {
  return (
    <div css={style.logo__group__notice__list} className="logo__group__notice__list">
      {
        list.map((item, index) =>
          <div key={index} css={style.logo__group__notice__item} className="logo__group__notice__item">
            {`⚠ Decoration Type "${item.groupName}" requires a minimum of ${item.minimumQty} items to unlock group pricing (current total: ${Math.floor(item.currentQty)}). You can still place your order, but group pricing will not be applied.`}
          </div>)
      }
    </div>
  )
}